import { Container } from '@mui/material';
import React, { useContext } from 'react';
import { ThemeContext } from '../../../contexts/theme-context';
import './expertise.css';

const expertiseData = [
  {
    title: 'Embedded & Firmware',
    items: ['ESP8266', 'ESP32', 'UART', 'SPI', 'I2C', 'Arduino', 'RTOS SDK']
  },
  {
    title: 'Hardware Design',
    items: ['PCB Design (KiCad)', 'Circuit Design', 'Sensor Integration', 'Power Design']
  },
  {
    title: 'Software Development',
    items: ['React', 'Flutter', 'Firebase', 'Python', 'API Development']
  },
  {
    title: 'AI/ML & Vision',
    items: ['TensorFlow', 'Keras', 'Image Classification', 'Image Processing', 'OCR Pipelines']
  },
  {
    title: 'Networking & Cloud',
    items: ['MQTT', 'REST APIs', 'Cloud Integration', 'Offline-first Architecture']
  }
];

function Expertise() {
  const { theme } = useContext(ThemeContext);

  return (
    <div style={{ backgroundColor: theme.secondary }}>
      <Container className='expertise' id='skills'>
        <h1 style={{ color: theme.primary }}>Core Expertise</h1>
        <div className='expertise-grid'>
          {expertiseData.map((section) => (
            <div
              key={section.title}
              className='expertise-card'
              style={{ background: theme.quaternary }}
            >
              <h2 style={{ color: theme.primary }}>{section.title}</h2>
              <ul>
                {section.items.map((item) => (
                  <li key={item} style={{ color: theme.tertiary }}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default Expertise;
